import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UNSAVED_CHANGES_DISPLAYED } from '../../features/analytics/analytics.constants';
import { trackEcg } from '../../features/analytics/thunks/track-ecg.thunk';
import { diagnosticChangedSelector } from '../../features/diagnostic/selectors/user-diagnostic.selectors';

export const useUnsavedChanged = () => {
  const dispatch = useDispatch();
  const changed = useSelector(diagnosticChangedSelector);

  useEffect(() => {
    if (changed === false) {
      return;
    }

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      dispatch(trackEcg(UNSAVED_CHANGES_DISPLAYED));
      return (event.returnValue = 'Changes that you made may not be saved.');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [changed, dispatch]);
};
